// import { useEffect, useState } from "react";
// import { FiEdit2 } from "react-icons/fi";
// import "./staffAttendance.css";

// const API = "https://bodhimaram.onrender.com/api/staff-attendance";

// function StaffAttendance() {
//   const [date, setDate] = useState("");
//   const [staff, setStaff] = useState([]);
//   const [attendance, setAttendance] = useState({});

//   const [showAttendance, setShowAttendance] = useState(false);
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [history, setHistory] = useState([]);

//   /* EDIT MODAL */
//   const [editOpen, setEditOpen] = useState(false);
//   const [editData, setEditData] = useState({
//     staff_id: "",
//     date: "",
//     status: "present",
//     extra_hours: 0
//   });

//   /* ================= DATE FORMAT (DISPLAY ONLY) ================= */
//   const formatDate = (sqlDate) => {
//     const [y, m, d] = sqlDate.split("-");
//     return `${d}-${m}-${y}`;
//   };

//   /* ================= LOAD STAFF ================= */
//   useEffect(() => {
//     fetch(`${API}/staff`)
//       .then(res => res.json())
//       .then(setStaff);
//   }, []);

//   /* ================= LOAD ATTENDANCE BY DATE ================= */
//   useEffect(() => {
//     if (!date) return;

//     fetch(`${API}?date=${date}`)
//       .then(res => res.json())
//       .then(rows => {
//         const map = {};
//         rows.forEach(r => {
//           map[r.staff_id] = {
//             status: r.status === "present" ? "Present" : "Absent",
//             remark: r.extra_hours
//           };
//         });
//         setAttendance(map);
//       });
//   }, [date]);

//   const handleStatus = (id, status) => {
//     setAttendance(prev => ({
//       ...prev,
//       [id]: { ...prev[id], status }
//     }));
//   };

//   const handleRemark = (id, remark) => {
//     setAttendance(prev => ({
//       ...prev,
//       [id]: { ...prev[id], remark }
//     }));
//   };

//   /* ================= SAVE DAILY ATTENDANCE ================= */
//   const handleSubmit = async () => {
//     if (!date) return alert("Select date");

//     const records = staff.map(s => ({
//       staff_id: s.id,
//       status:
//         attendance[s.id]?.status === "Present" ? "present" : "absent",
//       extra_hours: Number(attendance[s.id]?.remark || 0)
//     }));

//     const res = await fetch(API, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ date, records })
//     });

//     res.ok
//       ? alert("Attendance saved ✅")
//       : alert("Save failed ❌");
//   };

//   /* ================= LOAD HISTORY ================= */
//   const loadHistory = async (staffId) => {
//     setSelectedStaff(staffId);
//     const res = await fetch(`${API}/history/${staffId}`);
//     const data = await res.json();
//     setHistory(Array.isArray(data) ? data : []);
//   };

//   /* ================= OPEN EDIT (FINAL FIX) ================= */
//   const openEdit = async (staff_id, sqlDate) => {
//     const res = await fetch(
//       `${API}/single?staff_id=${staff_id}&date=${sqlDate}`
//     );

//     if (!res.ok) {
//       alert("Failed to load attendance");
//       return;
//     }

//     const data = await res.json();

//     if (!data) {
//       alert("Attendance record not found");
//       return;
//     }

//     setEditData({
//       staff_id,
//       date: sqlDate,
//       status: data.status,
//       extra_hours: data.extra_hours ?? 0
//     });

//     setEditOpen(true);
//   };

//   /* ================= SAVE EDIT ================= */
//   const saveEdit = async () => {
//     const res = await fetch(`${API}/single`, {
//       method: "PUT",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(editData)
//     });

//     if (res.ok) {
//       alert("Updated successfully ✅");
//       setEditOpen(false);
//       loadHistory(selectedStaff);
//     } else {
//       alert("Update failed ❌");
//     }
//   };

//   return (
//     <div className="a-page">
//       <div className="a-card">
//         <h2 style={{ color: "black" }} >Staff Attendance</h2>

//         {/* DATE */}
//         <div className="date-box">
//           <label  >Select Date</label>
//           <input
//             type="date"
//             value={date}
//             onChange={e => setDate(e.target.value)}
//           />
//         </div>

//         {/* ENTRY TABLE */}
// <div className="table-wrap">
//         <table className="a-table">
//           <thead>
//             <tr>
//               <th>Staff</th>
//               <th>Status</th>
//               <th>Extra Hours</th>
//             </tr>
//              </thead>
//              <tbody>
//             {staff.map(s => (
//               <tr key={s.id}>
//                 <td>{s.name}</td>

//                 <td className="st-btns">
//                   <button
//                     className={`btn present ${attendance[s.id]?.status === "Present" ? "active" : ""
//                       }`}
//                     onClick={() => handleStatus(s.id, "Present")}
//                   >
//                     Present
//                   </button>

//                   <button
//                     className={`btn absent ${attendance[s.id]?.status === "Absent" ? "active" : ""
//                       }`}
//                     onClick={() => handleStatus(s.id, "Absent")}
//                   >
//                     Absent
//                   </button>
//                 </td>

//                 <td>
//                   <input
//                     type="number"
//                     className="remark-input"
//                     value={attendance[s.id]?.remark || ""}
//                     onChange={e =>
//                       handleRemark(s.id, e.target.value)
//                     }
//                   />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
// </div>
//         {/* ACTIONS */}
//         <div className="action-row">
//           <button className="save-btn" onClick={handleSubmit}>
//             Save Attendance
//           </button>

//           <button
//             className="timing-btn"
//             onClick={() => setShowAttendance(!showAttendance)}
//           >
//             {showAttendance ? "Hide Attendance" : "Show Attendance"}
//           </button>
//         </div>

//         {/* HISTORY */}
//         {showAttendance && (
//           <div className="timing-panel">
//             <select onChange={e => loadHistory(e.target.value)}>
//               <option value="">Select Staff</option>
//               {staff.map(s => (
//                 <option key={s.id} value={s.id}>
//                   {s.name}
//                 </option>
//               ))}
//             </select>

//             {history.length > 0 && (
//               <div className="table-wrap">
//               <table className="history-table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Status</th>
//                     <th>Hours</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {history.map((h, i) => (
//                     <tr key={i}>
//                       <td>{formatDate(h.date)}</td>
//                       <td
//                         className={
//                           h.status === "present"
//                             ? "present-t"
//                             : "absent-t"
//                         }
//                       >
//                         {h.status}
//                       </td>
//                       <td>{h.extra_hours}</td>
//                       <td>
//                         <FiEdit2
//                           className="edit-icon"
//                           onClick={() =>
//                             openEdit(selectedStaff, h.date)
//                           }
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               </div>
//             )}
//           </div>
//         )}

//         {/* EDIT MODAL */}
//         {editOpen && (
//           <div className="modal-overlay">
//             <div className="modal-box">
//               <h3>Edit Attendance</h3>

//               <select
//                 value={editData.status}
//                 onChange={e =>
//                   setEditData({
//                     ...editData,
//                     status: e.target.value
//                   })
//                 }
//               >
//                 <option value="present">Present</option>
//                 <option value="absent">Absent</option>
//               </select>

//               <input
//                 type="number"
//                 value={editData.extra_hours}
//                 onChange={e =>
//                   setEditData({
//                     ...editData,
//                     extra_hours: e.target.value
//                   })
//                 }
//               />

//               <div className="modal-actions">
//                 <button onClick={() => setEditOpen(false)}>
//                   Cancel
//                 </button>
//                 <button onClick={saveEdit}>Save</button>
//               </div>
//             </div>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// }

// export default StaffAttendance;


import { useEffect, useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import "./staffAttendance.css";
import { Calendar } from "lucide-react";

const API = "https://bodhimaram.onrender.com/api/staff-attendance";

function StaffAttendance() {
  const [date, setDate] = useState("");
  const [staff, setStaff] = useState([]);
  const [attendance, setAttendance] = useState({});

  const [showAttendance, setShowAttendance] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [history, setHistory] = useState([]);


  // mobil
const [openStaffList, setOpenStaffList] = useState(false);

  /* EDIT MODAL */
  const [editOpen, setEditOpen] = useState(false);
  const [editData, setEditData] = useState({
    staff_id: "",
    date: "",
    status: "present",
    extra_hours: 0
  });

  /* ================= DATE FORMAT (DISPLAY ONLY) ================= */
  const formatDate = (sqlDate) => {
    const [y, m, d] = sqlDate.split("-");
    return `${d}-${m}-${y}`;
  };

  /* ================= LOAD STAFF ================= */
  useEffect(() => {
    fetch(`${API}/staff`)
      .then(res => res.json())
      .then(setStaff);
  }, []);

  /* ================= LOAD ATTENDANCE BY DATE ================= */
  useEffect(() => {
    if (!date) return;

    fetch(`${API}?date=${date}`)
      .then(res => res.json())
      .then(rows => {
        const map = {};
        rows.forEach(r => {
          map[r.staff_id] = {
            status: r.status === "present" ? "Present" : "Absent",
            remark: r.extra_hours
          };
        });
        setAttendance(map);
      });
  }, [date]);

  const handleStatus = (id, status) => {
    setAttendance(prev => ({
      ...prev,
      [id]: { ...prev[id], status }
    }));
  };

  const handleRemark = (id, remark) => {
    setAttendance(prev => ({
      ...prev,
      [id]: { ...prev[id], remark }
    }));
  };

  /* ================= SAVE DAILY ATTENDANCE ================= */
  const handleSubmit = async () => {
    if (!date) return alert("Select date");

    const records = staff.map(s => ({
      staff_id: s.id,
      status:
        attendance[s.id]?.status === "Present" ? "present" : "absent",
      extra_hours: Number(attendance[s.id]?.remark || 0)
    }));

    const res = await fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ date, records })
    });

    res.ok
      ? alert("Attendance saved ✅")
      : alert("Save failed ❌");
  };

  /* ================= LOAD HISTORY ================= */
  const loadHistory = async (staffId) => {
    setSelectedStaff(staffId);
    const res = await fetch(`${API}/history/${staffId}`);
    const data = await res.json();
    setHistory(Array.isArray(data) ? data : []);
  };

  /* ================= OPEN EDIT (FINAL FIX) ================= */
  const openEdit = async (staff_id, sqlDate) => {
    const res = await fetch(
      `${API}/single?staff_id=${staff_id}&date=${sqlDate}`
    );

    if (!res.ok) {
      alert("Failed to load attendance");
      return;
    }

    const data = await res.json();

    if (!data) {
      alert("Attendance record not found");
      return;
    }

    setEditData({
      staff_id,
      date: sqlDate,
      status: data.status,
      extra_hours: data.extra_hours ?? 0
    });

    setEditOpen(true);
  };

  /* ================= SAVE EDIT ================= */
  const saveEdit = async () => {
    const res = await fetch(`${API}/single`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editData)
    });

    if (res.ok) {
      alert("Updated successfully ✅");
      setEditOpen(false);
      loadHistory(selectedStaff);
    } else {
      alert("Update failed ❌");
    }
  };

  return (
    <div className="a-page"  >
      <div className="a-card"  >
        <h2 style={{ color: "black" }} >Staff Attendance</h2>

        {/* DATE */}
        <div className="date-box">
          <label  >Select Date</label>
          <input
            type="date"
            value={date}
            onChange={e => setDate(e.target.value)}
          />
        </div>

        {/* ENTRY TABLE */}
           <div className="table-wrap">
        <table className="a-table">
          <thead>
            <tr>
              <th>Staff</th>
              <th>Status</th>
              <th>Extra Hours</th>
            </tr>
             </thead>
             <tbody>
            {staff.map(s => (
              <tr key={s.id}>
                <td>{s.name}</td>

                <td className="st-btns">
                 <button
  className={`btn present ${attendance[s.id]?.status === "Present" ? "active" : ""}`}
  onClick={() => handleStatus(s.id, "Present")}
>
  <span className="desktop-text">Present</span>
  <span className="mobile-text">P</span>
</button>

<button
  className={`btn absent ${attendance[s.id]?.status === "Absent" ? "active" : ""}`}
  onClick={() => handleStatus(s.id, "Absent")}
>
  <span className="desktop-text">Absent</span>
  <span className="mobile-text">A</span>
</button>
                </td>

                <td>
                  <input
                    type="number"
                    className="remark-input"
                    value={attendance[s.id]?.remark || ""}
                    onChange={e =>
                      handleRemark(s.id, e.target.value)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
</div>
        {/* ACTIONS */}
        <div className="action-row">
          <button className="save-btn" onClick={handleSubmit}>
            Save Attendance
          </button>

          <button
            className="timing-btn"
            onClick={() => setShowAttendance(!showAttendance)}
          >
            {showAttendance ? "Hide Attendance" : "Show Attendance"}
          </button>
        </div>

        {/* HISTORY */}
        {showAttendance && (
          <div className="timing-panel">
            {/* <select onChange={e => loadHistory(e.target.value)}>
              <option value="">Select Staff</option>
              {staff.map(s => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select> */}
            <div className="desktop-staff-select">
  <select onChange={e => loadHistory(e.target.value)}>
    <option value="">Select Staff</option>
    {staff.map(s => (
      <option key={s.id} value={s.id}>
        {s.name}
      </option>
    ))}

  </select>
</div>

<div className="mobile-staff-select">
  <div
    className="mobile-select-header"
    onClick={() => setOpenStaffList(!openStaffList)}
  >
    {selectedStaff
      ? staff.find(s => String(s.id) === String(selectedStaff))?.name
      : "Select Staff"}
    <span>▼</span>
  </div>

  {openStaffList && (
    <div className="mobile-select-options">
      {staff.map(s => (
        <div
          key={s.id}
          className="mobile-option"
          onClick={() => {
            loadHistory(s.id);
            setOpenStaffList(false);
          }}
        >
          {s.name}
        </div>
      ))}
    </div>
  )}
</div>
            

            {history.length > 0 && (
              <div className="table-wrap">
              <table className="history-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Hours</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((h, i) => (
                    <tr key={i}>
                      <td><Calendar size={14} className="callender"/>{formatDate(h.date)}</td>
                      <td
                        className={
                          h.status === "present"
                            ? "present-t"
                            : "absent-t"
                        }
                      >
                        {h.status}
                      </td>
                      <td>{h.extra_hours}</td>
                      <td>
                        <FiEdit2
                          className="edit-icon"
                          onClick={() =>
                            openEdit(selectedStaff, h.date)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>


              
              </div>
            )}
          </div>
        )}

        {/* EDIT MODAL */}
        {editOpen && (
          <div className="modal-overlay">
            <div className="modal-box">
              <h3>Edit Attendance</h3>

              <select
                value={editData.status}
                onChange={e =>
                  setEditData({
                    ...editData,
                    status: e.target.value
                  })
                }
              >
                <option value="present">Present</option>
                <option value="absent">Absent</option>
              </select>

              <input
                type="number"
                value={editData.extra_hours}
                onChange={e =>
                  setEditData({
                    ...editData,
                    extra_hours: e.target.value
                  })
                }
              />

              <div className="modal-actions">
                <button onClick={() => setEditOpen(false)}>
                  Cancel
                </button>
                <button onClick={saveEdit}>Save</button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default StaffAttendance;
